module.exports = __webpack_public_path__ + "static/media/34DSS1.f5033613.jpg";